import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import gql from 'graphql-tag'

export const DOC = gql`
  mutation AddClusterOccupants(
    $tenantId: ID!
    $zoneId: ID!
    $appId: ID!
    $scenarioId: ID!
    $clusterId: ID!
    $employeeIds: [ID!]!
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            extra {
              space {
                addClusterOccupants(
                  clusterId: $clusterId
                  employeeIds: $employeeIds
                )
              }
            }
          }
        }
      }
    }
  }
`

export const executor = graphql.createExecutor<
  graphql.schema.AddClusterOccupantsMutation,
  undefined,
  graphql.schema.AddClusterOccupantsMutationVariables
>({
  query: DOC,
  transformer: graphql.transformers.OUT.always(undefined),
})
